import { z } from 'zod';

export const AlertResetSchema = z.object({
  systemFrontendId: z.string(),
  fullFrontendId: z.string(),
  accureId: z.string(),
  resetAtTime: z.date(),
});

export type AlertReset = z.infer<typeof AlertResetSchema>;
